import { getSingleFuelStationData } from '_services/accountsServices/fuelStationServices';
import { getSupplierDetailsData } from '_services/accountsServices/supplierServices';
import { CommonInput, CommonTextarea } from 'components';
import { UserContext } from 'context';
import { utils } from 'helper';
import Loading from 'pages/Loading';
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';

const FuelStationDetailsTab = ({ onDataFetch, loadingBarRef }) => {

    let { id } = useParams();
    const { masterData } = useContext(UserContext)
    const [detailsData, setDetailsData] = useState({})
    const [loading, setLoading] = useState(false);

    const getDataFuelStationDetails = async (id_1) => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                fuelstation_id: id_1,
            }
            const res = await getSingleFuelStationData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.fuelstation)
                onDataFetch(res?.data?.fuelstation)
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Finish the loading bar
            }
        }
    }

    useEffect(() => {
        if (id) {
            setLoading(true);
            getDataFuelStationDetails(id);
        }
    }, [id])

    return (
        <>
            {
                loading ? <div className='h-100 position-relative justify-content-center align-items-center d-flex'> <Loading /> </div> : (
                    <div className='fl-height-auto'>
                        <div className='_ptyDetail_bx'>
                            <div className="inrPrt_bxs">
                                <div className='_inrPrt_head'>Basic Details</div>
                                <div className='_inrPrt_flx'>
                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Fuel Station Name"
                                            label="Fuel Station Name *"
                                            name='name'
                                            value={detailsData?.name}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="Mobile Number"
                                            placeholder="Mobile Number"
                                            value={detailsData?.contact_no}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="Alternate Mobile Number"
                                            placeholder="Alternate Mobile Number"
                                            value={detailsData?.alt_contact_no}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="Email ID"
                                            placeholder="Email ID"
                                            value={detailsData?.email}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="Opening Balance (₹)"
                                            placeholder="Opening Balance (₹)"
                                            value={detailsData?.opening_balance ? `₹ ${detailsData?.opening_balance}` : ""}
                                            disabled
                                        />
                                    </div>
                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="As of Date"
                                            placeholder="As of Date"
                                            value={utils.dd_mm_yy_formatDate(detailsData?.as_of_date)}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="inrPrt_bxs ">
                                <div className='_inrPrt_head'> Address </div>
                                <div className='_inrPrt_flx _min_h_auto'>
                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="Address Line 1"
                                            placeholder="Address Line 1"
                                            value={detailsData?.address_line1}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="State"
                                            placeholder="State"
                                            value={detailsData?.state?.label}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="City"
                                            placeholder="City"
                                            value={detailsData?.city?.label}
                                            disabled
                                        />
                                    </div>

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="PIN Code"
                                            placeholder="PIN Code"
                                            value={detailsData?.pincode}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="inrPrt_bxs">
                                <div className='_inrPrt_head'>Tax Info</div>
                                <div className='_inrPrt_flx _min_h_auto'>
                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="GST Type"
                                            placeholder="GST Type"
                                            value={masterData?.gst_type_list?.filter((el) => (el?.id === detailsData?.gst_type))[0]?.name}
                                            disabled
                                        />
                                    </div>

                                    {
                                        detailsData?.gst_no ? (
                                            <div className='_divForth'>
                                                <CommonInput
                                                    type="text"
                                                    label="GST Number"
                                                    placeholder="GST Number"
                                                    value={detailsData?.gst_no}
                                                    disabled
                                                />
                                            </div>
                                        ) : <></>
                                    }

                                    <div className='_divForth'>
                                        <CommonInput
                                            type="text"
                                            label="GST State"
                                            placeholder="GST State"
                                            value={detailsData?.gst_state?.label}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="inrPrt_bxs">
                                <div className='_inrPrt_head'> Other Details </div>
                                {/* <div className='_inrPrt_flx'> */}
                                <div className='_divForth p-4 mb-5'>
                                    <CommonTextarea
                                        type="text"
                                        label="Notes"
                                        rows={5}
                                        placeholder="Notes"
                                        value={detailsData?.notes}
                                        disabled
                                    />
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default FuelStationDetailsTab